// import { embedDashboard } from '@superset-ui/embedded-sdk';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import DF from 'DisplayFramework';
//import DF from 'DisplayFramework';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
// import { loginSuperSet } from 'services/authentification';
import { SUPERSET_URL } from 'utils/config';

const SuperSetDocker = () => {
  const URL = SUPERSET_URL;

  const { id } = useParams<{ id: string }>();

  // const base_url = `https://scania-superset.utina.io:7090/api/v1/`;

  const base_url = URL + `/api/v1`;

  async function fetchAccessToken() {
    try {
      const body = {
        username: '',
        password: '',
        provider: 'db',
        refresh: true,
      };

      const response = await fetch(base_url + '/security/login', {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const jsonResponse = await response.json();
      return jsonResponse?.access_token;
    } catch (e) {
      console.error(e);
    }
  }

  async function get_csrf_token(access_token: string) {
    const res = await fetch(base_url + '/security/csrf_token/', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + access_token,
        Redirect: '*',
      },
      method: 'GET',
    });

    const complete_res = await res.json();
    return complete_res.result;
  }
  async function fetchGuestToken() {
    const accessToken = await fetchAccessToken();
    const csrf_token = await get_csrf_token(accessToken);

    try {
      const body = {
        resources: [
          {
            type: 'dashboard',
            id: id, //"76a6c368-94f1-4b45-8752-fa711a6be86b",
          },
        ],
        rls: [],
        user: {
          username: 'guest',
          first_name: 'guest',
          last_name: 'guest',
        },
      };
      const response = await fetch(base_url + '/security/guest_token/', {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          'X-CSRFToken': csrf_token,
          'X-CSRF-Token': csrf_token,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT',
          Redirect: '*',
        },
      });
      const jsonResponse = await response.json();
      return jsonResponse?.token;
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    const dashboard = document.getElementById('dashboard');

    const embed = async () => {
      if (dashboard) {
        await embedDashboard({
          id: '76a6c368-94f1-4b45-8752-fa711a6be86b', // given by the Superset embedding UI
          supersetDomain: URL,
          mountPoint: dashboard,
          fetchGuestToken: () => fetchGuestToken(),
          debug: true,
          dashboardUiConfig: {
            hideTitle: true,
            hideChartControls: true,
            hideTab: true,
          },
        });
      }
    };

    if (dashboard) {
      try {
        embed();
      } catch (error) {}
    }
  }, []);

  return (
    <DF.Provider pagcode="supersetdocker">
      <div id="dashboard"></div>
    </DF.Provider>
  );
};

export default SuperSetDocker;
